import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Save, RotateCcw, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api from "@/lib/api";
import { loadStudio } from "@/lib/studio";

const FIELDS = [
  ["name", "Ragione sociale / nome studio", "Studio Nouvelle"],
  ["toll_free", "Numero verde", "800 960 201"],
  ["phone", "Telefono", "089 214 5285"],
  ["email", "Email di contatto", "info@studionouvelle.it"],
  ["site", "Sito web", "www.studionouvelle.it"],
  ["hours", "Orario uffici", "Lun–Ven 09:00–13:00 · 15:30–19:00"],
];

export default function StudioSettings() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.studio().then(setD).catch(() => toast.error("Errore nel caricamento")); }, []);
  if (!d) return <div className="p-8 text-sm text-muted-foreground">Caricamento…</div>;
  const save = async () => {
    setSaving(true);
    try {
      const { defaults, site_url, ...payload } = d;
      const r = await api.saveStudio(payload);
      setD({ ...r, defaults });
      await loadStudio();
      toast.success("Contatti aggiornati: home, pannello, email e ricevute usano i nuovi dati");
    } catch (e) { toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Errore nel salvataggio"); }
    finally { setSaving(false); }
  };
  return (
    <div className="min-h-screen bg-background" data-testid="studio-settings-page">
      <header className="border-b border-border bg-card"><div className="mx-auto flex max-w-3xl items-center gap-3 px-5 py-4">
        <Button variant="ghost" size="icon" onClick={() => navigate("/")} data-testid="studio-back"><ArrowLeft className="h-5 w-5" /></Button>
        <div className="flex-1"><h1 className="font-display text-xl font-bold flex items-center gap-2"><Building2 className="h-5 w-5 text-primary" /> Contatti Studio Nouvelle</h1><p className="text-xs text-muted-foreground">Mostrati nel footer della home e del pannello, nelle email e nelle ricevute PDF</p></div>
        <Button variant="outline" className="gap-1.5 border-border" onClick={() => setD({ ...d, ...d.defaults })} data-testid="studio-reset"><RotateCcw className="h-4 w-4" /> Predefiniti</Button>
        <Button onClick={save} disabled={saving} className="gap-2" data-testid="studio-save"><Save className="h-4 w-4" /> {saving ? "Salvo…" : "Salva"}</Button>
      </div></header>
      <main className="mx-auto max-w-3xl px-5 py-6">
        <div className="grid gap-4 rounded-xl border border-border bg-card p-5 sm:grid-cols-2">
          {FIELDS.map(([k, label, ph]) => (
            <div key={k} className={`space-y-1.5 ${k === "hours" || k === "name" ? "sm:col-span-2" : ""}`}>
              <Label htmlFor={`studio-${k}`}>{label}</Label>
              <Input id={`studio-${k}`} value={d[k] || ""} onChange={(e) => setD({ ...d, [k]: e.target.value })} placeholder={ph} data-testid={`studio-${k}`} />
            </div>
          ))}
        </div>
        <p className="mt-3 text-xs text-muted-foreground">Lascia vuoto un campo per non mostrarlo. La brochure PDF scaricabile va rigenerata a parte.</p>
      </main>
    </div>
  );
}
